import { clsx } from 'clsx'
import { type FC } from 'react'

import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

import {
  getWillBeDeliveredLater,
  PRODUCT_STOCK_STATUS_DEFAULT,
  type ProductStockStatus,
  stockStatusMap,
} from '../../../product-page/components/ProductBuyBox/hooks/useProductStockStatus'
import { productAccessorStockIsAvailableButHasNotOnStockMessage } from '../../../product-page/model/productAccessor/productAccessorStockIsAvailableButHasNotOnStockMessage'

export const ExperimentOwnBrandsProductStockStatus: FC<{
  product: PimProductWithVariantsV1
}> = ({ product }) => {
  const useExperimentOwnBrandsOverlayProductStockStatus =
    (): ProductStockStatus => {
      if (!product.stock_status) {
        return PRODUCT_STOCK_STATUS_DEFAULT
      }
      if (productAccessorStockIsAvailableButHasNotOnStockMessage(product)) {
        return getWillBeDeliveredLater(product)
      }

      return (
        stockStatusMap[product.stock_status] ?? PRODUCT_STOCK_STATUS_DEFAULT
      )
    }
  const productStockStatus = useExperimentOwnBrandsOverlayProductStockStatus()

  return (
    <span
      className={clsx('font-medium', productStockStatus.color)}
      data-qa-id="product-status-qa-id"
    >
      {productStockStatus.message}
    </span>
  )
}
